// =============================================================================
// Notifications
// =============================================================================
export const NOTIFICATION_TYPES = [
    'task_complete',
    'needs_input',
    'error',
    'progress',
    'session_ended',
    'pr_created',
];
export const NOTIFICATION_URGENCIES = ['high', 'medium', 'low'];
export const NOTIFICATION_CHANNELS = ['in_app'];
//# sourceMappingURL=notification.js.map